import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import './PoweredBy.css';

const defaultVendors = [
  {
    name: 'Auth0',
    url: 'https://auth0.com/',
    tagline: 'Identity & MFA',
    logo: '/logos/auth0.svg',
  },
  {
    name: 'AWS KMS',
    url: 'https://aws.amazon.com/kms/',
    tagline: 'Encryption Key Management',
    logo: '/logos/aws.svg',
  },
  {
    name: 'Stripe',
    url: 'https://stripe.com/',
    tagline: 'Secure Payments',
    logo: '/logos/stripe.svg',
  },
  {
    name: 'Cloudflare',
    url: 'https://www.cloudflare.com/',
    tagline: 'Network & DDoS Protection',
    logo: '/logos/cloudflare.svg',
  },
  // You can uncomment when you want to reveal more
  // {
  //   name: 'MongoDB Atlas',
  //   url: 'https://www.mongodb.com/atlas',
  //   tagline: 'Encrypted Data Storage',
  //   logo: '/logos/mongodb.svg',
  // },
];

export default function PoweredBy({ vendors = defaultVendors, variant = 'default' }) {
  const { isAuthenticated } = useAuth0();

  // Don't show on authenticated pages to keep focus on the product
  // But always show if variant is 'always' or 'horizontal' (for footer)
  if (isAuthenticated && variant !== 'always' && variant !== 'horizontal') {
    return null;
  }

  return (
    <section className={`powered-by powered-by--${variant}`}>
      <div className="powered-by__inner">
        <h3 className="powered-by__title">Built on Enterprise Infrastructure</h3>
        <p className="powered-by__subtitle">
          We disclose select infrastructure partners for transparency.
          Core governance architecture and continuity frameworks are proprietary EternaVaults IP.
        </p>

        <div className="powered-by__grid">
          {vendors.map((v) => (
            <a
              key={v.name}
              href={v.url}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="powered-by__item"
              aria-label={`${v.name} – ${v.tagline}`}
              title={`${v.name} – ${v.tagline}`}
            >
              {v.logo ? (
                <img
                  src={v.logo}
                  alt={`${v.name} logo`}
                  className="powered-by__logo"
                  loading="lazy"
                  decoding="async"
                />
              ) : (
                <span className="powered-by__fallback">{v.name}</span>
              )}
              <span className="powered-by__tagline">{v.tagline}</span>
            </a>
          ))}
        </div>

        <p className="powered-by__footnote">
          Mention of third-party technology does not imply partnership or endorsement.
        </p>
      </div>
    </section>
  );
}

